import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Button,
  CircularProgress
} from '@mui/material';
import {
  Person as PersonIcon,
  ArrowForward as NavigateIcon
} from '@mui/icons-material';
import { getLocationId } from '../../../utils/locationTransformers';

const PersonsTab = ({ selectedLocation, locationPersons, loadingPersons }) => {
  const locationId = getLocationId(selectedLocation);

  if (loadingPersons) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (locationPersons.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <PersonIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
        <Typography variant="body1" color="text.secondary" gutterBottom>
          No persons at this location
        </Typography>
        <Button
          variant="outlined"
          startIcon={<NavigateIcon />}
          onClick={() => window.location.href = `/persons?location=${locationId}`}
          sx={{ mt: 1 }}
        >
          Manage Persons
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">
          Persons ({locationPersons.length})
        </Typography>
        <Button
          variant="outlined"
          size="small"
          startIcon={<NavigateIcon />}
          onClick={() => window.location.href = `/persons?location=${locationId}`}
        >
          View All
        </Button>
      </Box>
      <List>
        {locationPersons.map((person) => (
          <ListItem
            key={person.id}
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              mb: 1,
              bgcolor: 'background.paper'
            }}
          >
            <ListItemIcon>
              <PersonIcon color={person.inviteStatus === 'accepted' ? 'success' : 'action'} />
            </ListItemIcon>
            <ListItemText
              primary={person.friendlyName}
              secondary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                  {person.personTypeModel?.friendlyName && (
                    <Chip size="small" label={person.personTypeModel.friendlyName} variant="outlined" />
                  )}
                  {person.inviteStatus === 'accepted' && (
                    <Chip size="small" label="Active User" color="success" variant="outlined" />
                  )}
                  {person.inviteStatus === 'pending' && (
                    <Chip size="small" label="Invite Pending" color="warning" variant="outlined" />
                  )}
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default PersonsTab;
